
webpack.register(
    'components/timeline/animation-queue/animation-queue',
    function() {
        return require('components/timeline/animation-queue/animation-queue');
    },
    false
);
webpack.register(
    'components/timeline/animation-item/animation-item',
    function() {
        return require('components/timeline/animation-item/animation-item');
    },
    false
);
webpack.register(
    'components/card/featured/article/article',
    function() {
        return require('components/card/featured/article/article');
    },
    false
);
webpack.register(
    'components/card/featured/photo/photo',
    function() {
        return require('components/card/featured/photo/photo');
    },
    false
);
webpack.register(
    'components/card/featured/video/video',
    function() {
        return require('components/card/featured/video/video');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/timeline/animation-queue/animation-queue\"/>\r\n<can-import from=\"components/timeline/animation-item/animation-item\"/>\r\n\r\n<can-import from=\"components/card/featured/article/article\"/>\r\n<can-import from=\"components/card/featured/photo/photo\"/>\r\n<can-import from=\"components/card/featured/video/video\"/>\r\n\r\n<div class=\"c-vc-featured-wrapper\">\r\n  <div class=\"s-header-title\">Featured Content</div>\r\n  <animation-queue {^queue}=\"animationQueue\" {timeline-type}=\"timelineType\" {(active-card-index)}=\"activeCardIndex\" {(is-ad-finished)}=\"isAdFinished\">\r\n    {{#each cards}}\r\n      <animation-item {is-embed}=\"embed\" {queue}=\"animationQueue\" {timeline-type}=\"timelineType\" {(active-card-index)}=\"activeCardIndex\" {(is-ad-finished)}=\"isAdFinished\">\r\n          <div class=\"s-feed-item\">\r\n            {{#switch type}}\r\n              {{#case \"articleCard\"}}\r\n                <card-article card-index=\"{{cardIndex}}\" featured=\"true\" ($click)=\"onClick()\"></card-article>\r\n              {{/case}}\r\n              {{#case \"photoCard\"}}\r\n                <card-photo card-index=\"{{cardIndex}}\" {gallery}=\"gallery\" {tags}=\"tags\"></card-photo>\r\n              {{/case}}\r\n              {{#case \"videoCard\"}}\r\n                <card-video {card}=\"../\" {(active-card)}=\"activeCard\" {(active-card-index)}=\"activeCardIndex\" {(players-list)}=\"playersList\" card-index=\"{{cardIndex}}\" ($click)=\"onClick()\"></card-video>\r\n              {{/case}}\r\n            {{/switch}}\r\n          </div>\r\n      </animation-item>\r\n    {{/each}}\r\n  </animation-queue>\r\n</div>\r\n");